// extracted by mini-css-extract-plugin
export var sliderRange = "_s2-2";
export var sliderRoot = "_s2-0";
export var sliderThumb = "_s2-3";
export var sliderTrack = "_s2-1";